<app-loading
  mode="screen"
  [active]="(combinedLoading$ | async) ?? false"
></app-loading>
